<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="assetsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'assets-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Assets</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                >
                    <dx-button
                        text="New Asset"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addAsset()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('code')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>
            <dxi-column [dataField]="gridFieldName('type')" caption="Type" [lookup]="{ dataSource: assetTypeOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="150" cellTemplate="type"></dxi-column>
            <dxi-column [dataField]="gridFieldName('brand')" caption="Brand" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('model')" caption="Model" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('serial')" caption="Serial #" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('ownership')" caption="Ownership" [lookup]="{ dataSource: assetOwnershipOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('agreement')" caption="Agreement" [minWidth]="120" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('vendor')" caption="Vendor" [minWidth]="120" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('effectiveDate')" caption="Effective Date" dataType="date" [minWidth]="160" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('endDate')" caption="End Date" dataType="date" [minWidth]="160" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('condition')" caption="Condition" [lookup]="{ dataSource: assetConditionOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="120" cellTemplate="status"></dxi-column>
            <dxi-column [dataField]="gridFieldName('classification')" caption="Classification" [lookup]="{ dataSource: assetClassificationOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="150" [visible]="false" cellTemplate="classification"></dxi-column>
            <dxi-column [dataField]="gridFieldName('tagId')" caption="Tag ID" [minWidth]="100" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('businessUnitLocation')" caption="Location" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('mobileLabelPrinterCode')" caption="Mobile Label Printer" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('rfScanGunCode')" caption="RF Scan Gun" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('mheBatteryCode')" caption="MHE Battery" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('tabletComputerCode')" caption="Tablet Computer" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('slipSheetAttachCode')" caption="Slip Sheet Attach" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('clampLayerAttachCode')" caption="Clamp Layer Attach" [minWidth]="150" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Created" [minWidth]="100" dataType="date"></dxi-column>

            <div *dxTemplate="let cellInfo of 'cellCapitalCase'">
                {{ cellInfo.value | capitalCase }}
            </div>
            <div *dxTemplate="let cellInfo of 'classification'">
                {{ cellInfo.value | assetClassification }}
            </div>
            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    <a [routerLink]="`/assets/edit/${getCellData(cellInfo).id}`"
                       class="text-decoration-none">{{ getCellData(cellInfo).code }}</a>
                </div>
            </div>
            <div *dxTemplate="let cellInfo of 'type'">
                <span class="badge bg-info-subtle text-info">
                    {{ cellInfo.value | assetType }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(cellInfo.value)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('type')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: assetTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Type', stylingMode: 'filled', searchEnabled: true }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('brand')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Brand', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('model')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Model', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('serial')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Serial', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('ownership')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: assetOwnershipOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Ownership', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('agreement')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Agreement', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('vendor')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Vendor', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('effectiveDate')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Effective Date', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('endDate')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'End Date', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('condition')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: assetConditionOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Condition', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('classification')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: assetClassificationOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Classification', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('tagId')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Tag ID', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('businessUnitLocation')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Location', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('created')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>
